import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';   // Tailwind v4
import { App } from './App';

const root = document.getElementById('root');
if (root) createRoot(root).render(<StrictMode><App /></StrictMode>);
